import React, {Component} from 'react';
import {Spinner} from "../../Spinner";
import {HELP_DATA_NODE, LinkToArticle} from "../../help_center/LinkToArticle";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {DATA_NODE_CHANNEL} from "../../channels/channels";
import {ApiKeyComponent, ApiKeyTypeDataNode} from "../ApiKey";
import { withTranslation } from 'react-i18next';

class DataNodeComponentClass extends Component {

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo width={35} height={35} channel={DATA_NODE_CHANNEL}/>{t('data_node_component.title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderNotAccessStatus() {
        const { t } = this.props;
        return <div className="form-row">
            <div className="alert alert-info">
                {t('data_node_component.not_access_message')}
            </div>
        </div>
    }

    renderInnerComponents() {
        const { t } = this.props;
        const elements = [];
        elements.push(<div className="form-row">
            <label>{t('data_node_component.description')}&nbsp;&nbsp;➡️<LinkToArticle article={HELP_DATA_NODE}/></label>
        </div>);

        if(this.props.loading) {
            elements.push(<div className="box-loader"><Spinner color="positive"/></div>);
            return elements;
        }

        if(!this.props.hasAccessToModule) {
            elements.push(this.renderNotAccessStatus());
            return elements;
        }

        elements.push(<ApiKeyComponent key="button" apiKey={this.props.apiKey} keyType={ApiKeyTypeDataNode} />)
        return elements;
    }
}

export const DataNodeComponent = withTranslation()(DataNodeComponentClass);
export default DataNodeComponent;
